export default {"src":"/_next/static/media/quote.628eb3c1.svg","height":123,"width":160,"blurWidth":0,"blurHeight":0};